import React from 'react';
import { Route, Routes } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactErrorBoundary } from 'common/components/react-error-boundary';
import { queryClient } from 'common/react-query/query-client';
import { SessionReplayPage } from '../components/page';
const View: React.FC = () => {
  return <SessionReplayPage data-sentry-element="SessionReplayPage" data-sentry-component="View" data-sentry-source-file="index.tsx" />;
};

// for lazy loading route
// eslint-disable-next-line import/no-default-export
export default function SessionReplayView() {
  return <ReactErrorBoundary data-sentry-element="ReactErrorBoundary" data-sentry-component="SessionReplayView" data-sentry-source-file="index.tsx">
      <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-source-file="index.tsx">
        <Routes data-sentry-element="Routes" data-sentry-source-file="index.tsx">
          <Route path='' element={<View />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        </Routes>
      </QueryClientProvider>
    </ReactErrorBoundary>;
}